<template>
  <div data-testid="signatureForm-container" class="signature-form">
    <div v-if="!signature" data-testid="signatureForm-state-empty">
      <Button
        color="grey"
        :disabled="loading"
        :text="$t('checklist.sign')"
        outlined
        size="small"
        data-testid="signatureForm-button-sign"
        @click="$emit('open')"
      />

      <v-text-field
        :value="validationValue"
        class="signature-form__validationBridge"
        :rules="rules"
        data-testid="signatureForm-input-validationBridge"
      />
    </div>

    <div
      v-else
      class="signature-form__saved"
      data-testid="signatureForm-state-saved"
    >
      <div
        v-if="!readOnly"
        class="d-flex align-center justify-end mb-4"
        data-testid="signatureForm-section-actions"
      >
        <Button
          plain
          size="small"
          color="grey"
          :disabled="loading"
          :text="$t('checklist.replace_signature')"
          data-testid="signatureForm-button-replaceSignature"
          @click="$emit('open')"
        />

        <Button
          plain
          size="small"
          color="danger"
          class="ms-1"
          :disabled="loading"
          :text="$t('checklist.delete_signature')"
          data-testid="signatureForm-button-deleteSignature"
          @click="$emit('delete')"
        />
      </div>

      <div class="signature-form__previewLine">
        <MediaPreviewImage
          class="signature-form__preview"
          data-testid="signatureForm-image-preview"
          :src="signature"
          :height="previewHeight"
        />
      </div>

      <div
        class="signature-form__signer mt-2 font-weight-medium text-center body-2"
        data-testid="signatureForm-text-signerName"
      >
        {{ signerLabel }}
      </div>

      <v-text-field
        :value="validationValue"
        class="signature-form__validationBridge"
        :rules="rules"
        data-testid="signatureForm-input-validationBridge"
      />
    </div>
  </div>
</template>

<script>
import MediaPreviewImage from './MediaPreviewImage.vue'
import Button from '@/components/UI/Button.vue'

import { buildAccountFullName } from './signatureUtils'

export default {
  name: 'SignatureForm',

  components: {
    MediaPreviewImage,
    Button,
  },

  props: {
    signature: {
      type: Object,
      default: null,
    },
    account: {
      type: Object,
      default: null,
    },
    loading: Boolean,
    readOnly: Boolean,
    previewHeight: {
      type: Number,
      default: 200,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    signerLabel() {
      return buildAccountFullName(this.account) || ''
    },

    validationValue() {
      return this.signature ? 'signed' : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.signature-form__saved {
  width: 100%;
}

.signature-form__previewLine {
  border-bottom: 2px solid $color-blue-grey-darken2;
}

.signature-form__preview {
  border-radius: 0;
  min-height: 185px;
}

.signature-form__validationBridge :deep(.v-input__slot) {
  display: none !important;
}
</style>
